import usePageViewedEvent from './usePageViewedEvent'

export default usePageViewedEvent
